import {
  ProofOfCompletionExamLocation,
  ProofOfCompletionType,
  ExamStatementType,
} from '@sandtech-hub-monorepo/ehub-client';

export const getLabelByExamStatement = (
  statement: ExamStatementType,
  proofOfCompletionType: ProofOfCompletionType
) => {
  const isSalesforceAssociate =
    proofOfCompletionType === ProofOfCompletionType.SalesforceAssociate;
  const isSalesforceAdministrator =
    proofOfCompletionType === ProofOfCompletionType.SalesforceAdministrator;
  const isAwsSolutionsArchitect =
    proofOfCompletionType === ProofOfCompletionType.AwsSolutionsArchitect;

  const getCertificateName = () => {
    if (isSalesforceAssociate) return 'Salesforce Associate';
    if (isSalesforceAdministrator) return 'Salesforce Administrator';
    if (isAwsSolutionsArchitect) return 'AWS Solutions Architect';
    return 'Cloud Practitioner';
  };

  const certificateName = getCertificateName();

  switch (statement) {
    case ExamStatementType.DidNotCompleteExam:
      return "I was not able to complete my exam due to interruptions / didn't meet the requirements";
    case ExamStatementType.EarnedBeforeAlx:
      return `I earned the ${certificateName} Certificate before the ALX Program`;
    case ExamStatementType.TakenAndFailed:
      return `I have taken and failed the ${certificateName} Exam at my first attempt`;
    case ExamStatementType.TakenAndPassed:
      return `I have taken and passed the ${certificateName} Exam`;
    default:
      return '';
  }
};

export const getExplanationTextByProofOfCompletionType = (
  type: ProofOfCompletionType
) => {
  switch (type) {
    case ProofOfCompletionType.AwsCloudComputing:
      return 'Please submit your Cloud Practitioner certificate in order to proceed to AWS Solutions Architect course.';
    case ProofOfCompletionType.AwsSolutionsArchitect:
      return 'Please submit your AWS Solutions Architect certificate.';
    case ProofOfCompletionType.SalesforceAssociate:
      return 'Please submit your Salesforce Associate certificate in order to proceed to Salesforce Administrator course.';
    case ProofOfCompletionType.SalesforceAdministrator:
      return 'Please submit your Salesforce Administrator certificate.';
    default:
      return 'Please submit your proof of completion.';
  }
};

export const getModalSubtitleByProofOfCompletionType = (
  type: ProofOfCompletionType
) => {
  switch (type) {
    case ProofOfCompletionType.AwsCloudComputing:
      return 'Congratulations on completing the AWS Cloud Practitioner retake exam! To verify your certificate eligibility, please submit your exam results through this form:';
    case ProofOfCompletionType.AwsSolutionsArchitect:
      return 'Congratulations on completing the AWS Solutions Architect course! To verify your certificate eligibility, please submit your exam results through this form:';
    case ProofOfCompletionType.SalesforceAssociate:
      return 'Congratulations on completing the Salesforce Associate course! To verify your certificate eligibility, please submit your exam results through this form:';
    case ProofOfCompletionType.SalesforceAdministrator:
      return 'Congratulations on completing the Salesforce Administrator course! To verify your certificate eligibility, please submit your exam results through this form:';
    default:
      return 'Please submit your exam results through this form';
  }
};

export const getExamLocationOptions = (type: ProofOfCompletionType) => [
  {
    value: ProofOfCompletionExamLocation.Online,
    label: 'Online with a Virtual Proctor at a location of your choosing',
  },
  {
    value: ProofOfCompletionExamLocation.Onsite,
    label: 'Onsite at a Pearson Vue Test Center',
  },
  {
    value: ProofOfCompletionExamLocation.OnlineVpAlxHub,
    label: 'Online with a Virtual Proctor at an ALX hub',
  },
];
